import React from 'react';

export interface InputHiddenProps {
  name: string;
  value: string | number | readonly string[];
}

export const InputHidden: React.FC<InputHiddenProps> = ({ name, value }) => {
  return (
    <input 
      type="hidden" 
      name={name} 
      value={value} 
    />
  );
};